export default __webpack_public_path__ + "static/media/yeti.80bb4681.png";